//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './OutstandingReceivablesClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetOutstandingReceivablesQueryParameters = {
  invoiceNumber?: string | undefined ;
  isOverdueDebt?: boolean | undefined ;
  debt?: boolean | undefined ;
  repaid?: boolean | undefined ;
  credited?: boolean | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export function getUrl(invoiceNumber?: string | undefined, isOverdueDebt?: boolean | undefined, debt?: boolean | undefined, repaid?: boolean | undefined, credited?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/outstanding-receivables?";
if (invoiceNumber === null)
    throw new Error("The parameter 'invoiceNumber' cannot be null.");
else if (invoiceNumber !== undefined)
    url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
if (isOverdueDebt === null)
    throw new Error("The parameter 'isOverdueDebt' cannot be null.");
else if (isOverdueDebt !== undefined)
    url_ += "IsOverdueDebt=" + encodeURIComponent("" + isOverdueDebt) + "&";
if (debt === null)
    throw new Error("The parameter 'debt' cannot be null.");
else if (debt !== undefined)
    url_ += "Debt=" + encodeURIComponent("" + debt) + "&";
if (repaid === null)
    throw new Error("The parameter 'repaid' cannot be null.");
else if (repaid !== undefined)
    url_ += "Repaid=" + encodeURIComponent("" + repaid) + "&";
if (credited === null)
    throw new Error("The parameter 'credited' cannot be null.");
else if (credited !== undefined)
    url_ += "Credited=" + encodeURIComponent("" + credited) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.OutstandingReceivablesResponseDto, unknown, Types.OutstandingReceivablesResponseDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.OutstandingReceivablesResponseDto, unknown, Types.OutstandingReceivablesResponseDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetOutstandingReceivablesQueryParameters): QueryKey;
export function getQueryKey(invoiceNumber?: string | undefined, isOverdueDebt?: boolean | undefined, debt?: boolean | undefined, repaid?: boolean | undefined, credited?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { invoiceNumber, isOverdueDebt, debt, repaid, credited, offset, limit, sortBy, sortOrder,  } = params[0] as GetOutstandingReceivablesQueryParameters;

    return trimArrayEnd([
        'OutstandingReceivablesClient',
        'get',
        invoiceNumber as any,
        isOverdueDebt as any,
        debt as any,
        repaid as any,
        credited as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'OutstandingReceivablesClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as boolean | undefined,       context.queryKey[4] as boolean | undefined,       context.queryKey[5] as boolean | undefined,       context.queryKey[6] as boolean | undefined,       context.queryKey[7] as number | null | undefined,       context.queryKey[8] as number | null | undefined,       context.queryKey[9] as string | null | undefined,       context.queryKey[10] as Types.SortOrder | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.OutstandingReceivablesResponseDto, TError = unknown>(dto: GetOutstandingReceivablesQueryParameters, options?: Omit<UseQueryOptions<Types.OutstandingReceivablesResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets data.
 * @param invoiceNumber (optional) 
 * @param isOverdueDebt (optional) 
 * @param debt (optional) 
 * @param repaid (optional) 
 * @param credited (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetQuery<TSelectData = Types.OutstandingReceivablesResponseDto, TError = unknown>(invoiceNumber?: string | undefined, isOverdueDebt?: boolean | undefined, debt?: boolean | undefined, repaid?: boolean | undefined, credited?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.OutstandingReceivablesResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.OutstandingReceivablesResponseDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.OutstandingReceivablesResponseDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let invoiceNumber: any = undefined;
  let isOverdueDebt: any = undefined;
  let debt: any = undefined;
  let repaid: any = undefined;
  let credited: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ invoiceNumber, isOverdueDebt, debt, repaid, credited, offset, limit, sortBy, sortOrder,  } = params[0] as GetOutstandingReceivablesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [invoiceNumber, isOverdueDebt, debt, repaid, credited, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.OutstandingReceivablesResponseDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(invoiceNumber, isOverdueDebt, debt, repaid, credited, offset, limit, sortBy, sortOrder),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.OutstandingReceivablesResponseDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets data.
 * @param invoiceNumber (optional) 
 * @param isOverdueDebt (optional) 
 * @param debt (optional) 
 * @param repaid (optional) 
 * @param credited (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.OutstandingReceivablesResponseDto | undefined) => Types.OutstandingReceivablesResponseDto, invoiceNumber?: string | undefined, isOverdueDebt?: boolean | undefined, debt?: boolean | undefined, repaid?: boolean | undefined, credited?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(getQueryKey(invoiceNumber, isOverdueDebt, debt, repaid, credited, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Gets data.
 * @param invoiceNumber (optional) 
 * @param isOverdueDebt (optional) 
 * @param debt (optional) 
 * @param repaid (optional) 
 * @param credited (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.OutstandingReceivablesResponseDto | undefined) => Types.OutstandingReceivablesResponseDto) {
  queryClient.setQueryData(queryKey, updater);
}